import type { CategoryFlag } from '../data/types'

interface Props {
  flags: CategoryFlag[]
  onChange: (flags: CategoryFlag[]) => void
  nextId: (label: string) => string
}

/**
 * Free-form labels, and nothing else. They mean whatever you decide; nothing is
 * derived from one. Whether a category's time counts is the category's own
 * business, set on its row above.
 */
export function FlagsEditor({ flags, onChange, nextId }: Props) {
  return (
    <div className="flex flex-col gap-2">
      {flags.length > 0 ? (
        <ul className="flex flex-col gap-1.5">
          {flags.map((flag, index) => (
            <li key={flag.id} className="flex items-center gap-2">
              <input
                value={flag.label}
                onChange={(event) =>
                  onChange(
                    flags.map((candidate, i) =>
                      i === index ? { ...candidate, label: event.target.value } : candidate,
                    ),
                  )
                }
                aria-label="Flag name"
                className="min-w-0 flex-1 rounded-md border border-line bg-bg px-2 py-1 text-[13px] outline-none focus:border-line-strong"
              />
              <button
                type="button"
                onClick={() => onChange(flags.filter((_, i) => i !== index))}
                aria-label={`Remove ${flag.label}`}
                className="shrink-0 rounded border border-line px-1.5 py-0.5 text-[12px] text-faint transition-colors duration-150 hover:border-danger/40 hover:text-danger"
              >
                Remove
              </button>
            </li>
          ))}
        </ul>
      ) : null}

      <button
        type="button"
        onClick={() => onChange([...flags, { id: nextId('flag'), label: 'New flag' }])}
        className="self-start rounded-md border border-line-strong px-2.5 py-1 text-[13px] font-medium text-dim transition-colors duration-150 hover:text-text"
      >
        Add flag
      </button>
    </div>
  )
}
